import React, { useState, useEffect } from "react"
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import { validarCotizacionVenta } from './Validations/TrabajadoresValidation';
import config from './Componentes/config';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';
import { formatRemuneracion } from './Validations/TrabajadoresValidation';
import { formatearRutEnTiempoReal } from './Componentes/rutUtils';
import './ccss/App.css';
import './ccss/CotizacionVenta.css';
import { generarPDFVenta } from "./Documentos/CotizacionVentaPDF";
import Axios from 'axios';
import Swal from 'sweetalert2';
import { registrarLog } from './Componentes/logService';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

const OPCIONES_CONDICION_PAGO = ['Contado', 'Contra factura', 'Mensual', '15 días', '30 días', '45 días', '60 días', '90 días'];
const OPCION_OTRA = 'Otra';

// Largos máximos según las columnas de la BD (ver server/database/cotizacion_venta_ajustes.sql)
const LARGO_MAX = {
    nombreEmpresa: 100, direccion: 100, telefono: 20, email: 100, condicionPago: 50,
    titulo: 100, observacion: 200, unidad: 50, articulos: 255
};

const soloDigitos = (valor) => String(valor ?? '').replace(/\D/g, '');
const aNumero = (valor) => parseInt(soloDigitos(valor), 10) || 0;
const filaVacia = (item) => ({ ID: null, Item: item, Cantidad: "", Unidad: "", Articulos: "", Valor: "" });
// El textarea de Artículos crece con su contenido; como ref se ajusta también
// al cargar una cotización existente.
const ajustarAlto = (el) => {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
};
const filaTieneDatos = (row) => Boolean(row.Cantidad || String(row.Unidad).trim() || String(row.Articulos).trim() || row.Valor);



// Estados para el componente Trabajadores


function CotizacionVenta() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const [cookiesEmpresa] = useCookies(['idEmpresa']);
    const imageUrl = cardImages[cookies.selectedCard]
    // El backend verifica el permiso del módulo, así que todas las llamadas
    // deben identificar al usuario.
    const userId = cookies.userId;
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);
    const [nombreEmpresa, setnombreEmpresa] = useState("");
    const [direccion, setDireccion] = useState("");
    const [rutempresa, setrutempresa] = useState("");
    const [numerocotizacion, setnumerocotizacion] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setemail] = useState("");
    const [duracionCotizacion, setDuracionCotizacion] = useState("");
    const [CondicionPago, setCondicionPago] = useState("");
    const [condicionOtra, setCondicionOtra] = useState(false); // true = condición de pago escrita a mano
    const [TituloCotizacion, setTituloCotizacion] = useState("");
    const [Observacion, setObservacion] = useState("");
    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };
    const [utilidad, setUtilidad] = useState("");
    const [idCotizacion, setidCotizacion] = useState("");
    const [listadoCotizacion, setListadoCotizacion] = useState([]);
    const [editar, setEditar] = useState(false);
    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;
    const [empresa, setEmpresa] = useState(getEmpresaName(cookies.selectedCard));
    // Cantidad se guarda como dígitos y Valor como texto con separador de miles;
    // Valor C/U y Valor Neto se calculan al vuelo para que siempre reflejen la utilidad actual.
    const [rows, setRows] = useState([filaVacia(1)]);

    const calcularFila = (row) => {
        const valorCUExacto = aNumero(row.Valor) * (1 + (aNumero(utilidad) / 100));
        return {
            valorCU: Math.round(valorCUExacto),
            valorNeto: Math.round(valorCUExacto * aNumero(row.Cantidad))
        };
    };

    const agregarFila = () => {
        setRows([...rows, filaVacia(rows.length + 1)]);
    };

    const actualizarFila = (index, field, value) => {
        let valor = value;
        if (field === "Cantidad") valor = soloDigitos(value).slice(0, 6);
        if (field === "Valor") valor = formatRemuneracion(soloDigitos(value).slice(0, 10));

        setRows(rows.map((row, i) => (i === index ? { ...row, [field]: valor } : row)));
    };

    const calcularTotal = () => rows.reduce((total, row) => total + calcularFila(row).valorNeto, 0);

    // Quitar una fila solo afecta la pantalla: el cambio llega a la BD al
    // registrar o guardar la cotización, y "Cancelar" lo descarta.
    const eliminarFila = async (index) => {
        if (filaTieneDatos(rows[index])) {
            const res = await Swal.fire({
                title: '¡Cuidado!',
                html: editar
                    ? '¿Quitar el item? El cambio se aplicará al guardar la cotización.'
                    : '¿Está seguro de quitar el item de la cotización?',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, quitar'
            });
            if (!res.isConfirmed) return;
        }

        const restantes = rows.filter((_, i) => i !== index).map((row, i) => ({ ...row, Item: i + 1 }));
        setRows(restantes.length > 0 ? restantes : [filaVacia(1)]);
    };

    const rows2 = rows.map(row => {
        const { valorCU, valorNeto } = calcularFila(row);
        return {
            item: row.Item,
            cantidad: row.Cantidad,
            unidad: row.Unidad,
            articulos: row.Articulos,
            valor: formatRemuneracion(valorCU.toString()),
            valorneto: formatRemuneracion(valorNeto.toString()),
        };
    });

    const datosCotizacion = {
        nombreEmpresa,
        empresa,
        direccion,
        numerocotizacion,
        rutempresa,
        telefono,
        email,
        duracionCotizacion,
        CondicionPago,
        TituloCotizacion,
        Observacion,
        idCotizacion
    };

    // Las filas completamente vacías (por ejemplo, una agregada de más) no se guardan.
    const itemsConDatos = () => rows.filter(filaTieneDatos);

    const validarFormulario = () => validarCotizacionVenta({
        idEmpresa: cookies.idEmpresa,
        nombreEmpresa,
        direccion,
        rutEmpresa: rutempresa,
        telefono,
        email,
        duracion: duracionCotizacion,
        condicionPago: CondicionPago,
        titulo: TituloCotizacion,
        utilidad,
        items: itemsConDatos()
    });

    const armarDatos = () => ({
        userId,
        idEmpresa: cookiesEmpresa.idEmpresa,
        NombreEmpresa: nombreEmpresa,
        Direccion: direccion,
        RutEmpresa: rutempresa,
        Telefono: telefono,
        Email: email,
        duracionCotizacion: duracionCotizacion,
        CondicionPago: CondicionPago,
        TituloCotizacion: TituloCotizacion,
        Observacion: Observacion,
        utilidad: utilidad,
        items: itemsConDatos().map(row => ({
            ID: row.ID || null,
            cantidad: aNumero(row.Cantidad),
            unidad: row.Unidad,
            articulos: row.Articulos,
            valor: aNumero(row.Valor)
        }))
    });

    const mensajeDeError = (error) => error?.response?.data?.error || 'Hubo un error al enviar la petición.';

    const RegistraCotizacion = async () => {
        const mensajeError = validarFormulario();
        if (mensajeError) {
            Swal.fire('Advertencia', mensajeError, 'warning');
            return; // Detiene la función si falla la validación
        }
        try {
            const response = await Axios.post(`${config.API_URL}/RegistraCotizacionVenta`, armarDatos(), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const idGenerado = response.data.idGenerado;
            cargaCotizacion();
            // Recargar desde la BD deja la cotización en modo edición con los IDs
            // de sus ítems, así un segundo clic guarda cambios en vez de duplicarla.
            await obtenerCotizacion(idGenerado);
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Cotizacion Venta',
                Detalle: `Registro de cotizacion N° ${response.data.numeroCotizacion}`,
                Estado: 'Éxito',
            });
            Swal.fire(
                '¡Éxito!',
                `La cotización N° ${response.data.numeroCotizacion} se registró exitosamente`,
                'success'
            );
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Cotizacion venta',
                Detalle: `Registro de cotizacion - Error: ${error.message || error}`,
                Estado: 'Fallo',
            });
            Swal.fire('¡Algo pasó!', mensajeDeError(error), 'error');
        }
    }

    const cargaCotizacion = () => {
        const idEmpresa = cookiesEmpresa.idEmpresa;
        Axios.get(`${config.API_URL}/cargaCotizacionVenta/${idEmpresa}`, { params: { userId } })
            .then(res => {
                if (Array.isArray(res.data)) {
                    setListadoCotizacion(res.data);
                } else {
                    console.error('La respuesta no es un array:', res.data);
                    setListadoCotizacion([]);
                }
            })
            .catch(err => {
                console.error("Error al obtener los datos:", err);
            });
    }

    const cargarCondicionPago = (valor) => {
        const texto = String(valor ?? '').trim();
        const opcion = OPCIONES_CONDICION_PAGO.find(o => o.toLowerCase() === texto.toLowerCase());
        setCondicionPago(opcion || texto);
        setCondicionOtra(!opcion && texto !== '');
    };

    const obtenerCotizacion = async (idCotizacion) => {
        try {
            const response = await Axios.get(`${config.API_URL}/obtenerCotizacionVenta/${idCotizacion}`, { params: { userId } });
            if (response.data.success) {
                setEditar(true);
                const { cotizacion, costosVariables } = response.data;
                setnombreEmpresa(cotizacion.Nombre_Empresa);
                setDireccion(cotizacion.Direccion);
                setrutempresa(formatearRutEnTiempoReal(cotizacion.RutEmpresa || ''));
                setTelefono(cotizacion.Telefono);
                setemail(cotizacion.Email);
                setDuracionCotizacion(String(cotizacion.DuracionCotizacion ?? ''));
                cargarCondicionPago(cotizacion.CondicionPago);
                setTituloCotizacion(cotizacion.TituloCotizacion);
                setObservacion(cotizacion.Observacion);
                setUtilidad(String(cotizacion.Utilidad ?? ''));
                setidCotizacion(cotizacion.ID);
                setnumerocotizacion(cotizacion.NumeroCotizacion || "");
                const filas = costosVariables.map((row, i) => ({
                    ID: row.ID,
                    Item: i + 1,
                    Cantidad: String(row.Cantidad ?? ''),
                    Unidad: row.Unidad || '',
                    Articulos: row.Articulos || '',
                    Valor: formatRemuneracion(String(row.Valor ?? ''))
                }));
                setRows(filas.length > 0 ? filas : [filaVacia(1)]);
            } else {
                console.error("Error:", response.data.message);
            }
        } catch (error) {
            console.error("Error al obtener la cotización:", error);
            Swal.fire('¡Algo pasó!', 'No se pudo cargar la cotización.', 'error');
        }
    };

    const UpdateCotizacionVenta = async () => {
        const mensajeError = validarFormulario();
        if (mensajeError) {
            Swal.fire('Advertencia', mensajeError, 'warning');
            return; // Detiene la función si falla la validación
        }
        try {
            await Axios.post(`${config.API_URL}/UpdateCotizacionVenta`, { ...armarDatos(), idCotizacion }, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Cotizacion',
                Detalle: `actualizacion de cotizacion venta`,
                Estado: 'Éxito',
            });
            Swal.fire(
                '¡Éxito!',
                'La cotizacion se actualizo exitosamente',
                'success'
            );
            limpiarCampos();
            cargaCotizacion();
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Cotizacion',
                Detalle: `Actualizacion de cotizacion venta - Error: ${error.message || error}`,
                Estado: 'Fallo',
            });
            Swal.fire('¡Algo pasó!', mensajeDeError(error), 'error');
        }
    };

    const limpiarCampos = () => {
        setnombreEmpresa("");
        setDireccion("");
        setrutempresa("");
        setTelefono("");
        setemail("");
        setDuracionCotizacion("");
        setCondicionPago("");
        setCondicionOtra(false);
        setTituloCotizacion("");
        setObservacion("");
        setUtilidad("");
        setidCotizacion("");
        setnumerocotizacion("");
        setRows([filaVacia(1)]);
        setEditar(false);
    }

    const exportarPDF = () => {
        const mensajeError = validarFormulario();
        if (mensajeError) {
            Swal.fire('Advertencia', mensajeError, 'warning');
            return;
        }
        generarPDFVenta(rows2.filter((_, i) => filaTieneDatos(rows[i])), datosCotizacion);
    };

    const DeleteCotizacionVenta = async (id) => {
        try {
            const res = await Swal.fire({
                title: '¡Cuidado!',
                html: '¿Está seguro de eliminar la cotización?.',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar!'
            });

            if (res.isConfirmed) {
                await Axios.delete(`${config.API_URL}/EliminarCotizacionVenta/${id}`, { params: { userId } });
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Cotizacion Venta',
                    Detalle: `Delete de Cotizacion venta: ${id}`,
                    Estado: 'Éxito',
                });
                cargaCotizacion();
                limpiarCampos();

                Swal.fire(
                    'Eliminado!',
                    'La cotización se ha sido eliminado exitosamente',
                    'success'
                );
            }
        } catch (error) {
            console.error('Error al eliminar la cotizacion:', error);
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Cotizacion Venta',
                Detalle: `Delete de Cotizacion venta: ${id} - error ${error}`,
                Estado: 'Fallo',
            });
            Swal.fire(
                '¡Algo pasó!',
                'Hubo un error al eliminar la cotización. Intente nuevamente.',
                'error'
            );
        }
    }

    useEffect(() => {
        cargaCotizacion();
    }, []);

    const opcionCondicionPago = condicionOtra
        ? OPCION_OTRA
        : (OPCIONES_CONDICION_PAGO.includes(CondicionPago) ? CondicionPago : '');

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card shadow mb-4">
                                        <div class="card-header py-3">
                                            <h6 class="m-0 font-weight-bold text-primary">
                                                {editar
                                                    ? `Editando cotización de venta${numerocotizacion ? ` N° ${numerocotizacion}` : ''} - ${empresa}`
                                                    : `Crear cotizaciones de venta para ${empresa}`}
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div className="cotventa-form">
                                                <h6 className="cotventa-seccion">Datos del cliente</h6>
                                                <div className="row">
                                                    <div className="col-md-6 form-group">
                                                        <label htmlFor="cv-nombre">Nombre empresa *</label>
                                                        <input id="cv-nombre" type="text" className="form-control" value={nombreEmpresa} maxLength={LARGO_MAX.nombreEmpresa}
                                                            placeholder="Razón social del cliente"
                                                            onChange={(event) => setnombreEmpresa(event.target.value)} />
                                                    </div>
                                                    <div className="col-md-3 form-group">
                                                        <label htmlFor="cv-rut">RUT *</label>
                                                        <input id="cv-rut" type="text" className="form-control" value={rutempresa} maxLength={12}
                                                            placeholder="12.345.678-9"
                                                            onChange={(event) => setrutempresa(formatearRutEnTiempoReal(event.target.value))} />
                                                    </div>
                                                    <div className="col-md-3 form-group">
                                                        <label htmlFor="cv-telefono">Teléfono</label>
                                                        <input id="cv-telefono" type="tel" className="form-control" value={telefono} maxLength={LARGO_MAX.telefono}
                                                            placeholder="+56 9 1234 5678"
                                                            onChange={(event) => setTelefono(event.target.value.replace(/[^\d+ ]/g, ''))} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 form-group">
                                                        <label htmlFor="cv-direccion">Dirección *</label>
                                                        <input id="cv-direccion" type="text" className="form-control" value={direccion} maxLength={LARGO_MAX.direccion}
                                                            placeholder="Ej: Av. Los Carrera 301, Concepción"
                                                            onChange={(event) => setDireccion(event.target.value)} />
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        <label htmlFor="cv-email">E-mail</label>
                                                        <input id="cv-email" type="email" className="form-control" value={email} maxLength={LARGO_MAX.email}
                                                            placeholder="contacto@empresa.cl"
                                                            onChange={(event) => setemail(event.target.value.trim())} />
                                                    </div>
                                                </div>

                                                <h6 className="cotventa-seccion">Condiciones de la cotización</h6>
                                                <div className="row">
                                                    <div className="col-lg-6 form-group">
                                                        <label htmlFor="cv-titulo">Título *</label>
                                                        <input id="cv-titulo" type="text" className="form-control" value={TituloCotizacion} maxLength={LARGO_MAX.titulo}
                                                            placeholder="Ej: Suministro de EPP faena Los Lobos"
                                                            onChange={(event) => setTituloCotizacion(event.target.value)} />
                                                    </div>
                                                    <div className="col-sm-4 col-lg-2 form-group">
                                                        <label htmlFor="cv-duracion">Validez *</label>
                                                        <div className="input-group">
                                                            <input id="cv-duracion" type="text" inputMode="numeric" className="form-control" value={duracionCotizacion}
                                                                placeholder="Ej: 30"
                                                                onChange={(event) => setDuracionCotizacion(soloDigitos(event.target.value).slice(0, 3))} />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text">días</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 col-lg-2 form-group">
                                                        <label htmlFor="cv-condicion">Condición de pago *</label>
                                                        <select id="cv-condicion" className="form-control" value={opcionCondicionPago}
                                                            onChange={(event) => {
                                                                const valor = event.target.value;
                                                                setCondicionOtra(valor === OPCION_OTRA);
                                                                setCondicionPago(valor === OPCION_OTRA ? '' : valor);
                                                            }}>
                                                            <option value="">Seleccione...</option>
                                                            {OPCIONES_CONDICION_PAGO.map(opcion => (
                                                                <option key={opcion} value={opcion}>{opcion}</option>
                                                            ))}
                                                            <option value={OPCION_OTRA}>Otra...</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-4 col-lg-2 form-group">
                                                        <label htmlFor="cv-utilidad">Utilidad *</label>
                                                        <div className="input-group">
                                                            <input id="cv-utilidad" type="text" inputMode="numeric" className="form-control" value={utilidad}
                                                                placeholder="Ej: 20"
                                                                onChange={(event) => setUtilidad(soloDigitos(event.target.value).slice(0, 3))} />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {condicionOtra && (
                                                    <div className="row">
                                                        <div className="col-lg-6 offset-lg-6 form-group">
                                                            <label htmlFor="cv-condicion-otra">Detalle condición de pago *</label>
                                                            <input id="cv-condicion-otra" type="text" className="form-control" value={CondicionPago} maxLength={LARGO_MAX.condicionPago}
                                                                placeholder="Ej: 50% anticipo y 50% contra entrega"
                                                                onChange={(event) => setCondicionPago(event.target.value)} />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="row">
                                                    <div className="col-12 form-group">
                                                        <label htmlFor="cv-observacion">Observación</label>
                                                        <input id="cv-observacion" type="text" className="form-control" value={Observacion} maxLength={LARGO_MAX.observacion}
                                                            placeholder="Opcional: plazos de entrega, condiciones especiales, etc."
                                                            onChange={(event) => setObservacion(event.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 className="cotventa-seccion">Ítems de la cotización</h6>
                                            <div className="cotventa-items">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th className="cv-col-num">N°</th>
                                                            <th className="cv-col-cantidad">Cantidad</th>
                                                            <th className="cv-col-unidad">Unidad</th>
                                                            <th>Artículo / descripción</th>
                                                            <th className="cv-col-valor">Valor S/U</th>
                                                            <th className="cv-col-calculado">Valor C/U</th>
                                                            <th className="cv-col-calculado">Valor neto</th>
                                                            <th className="cv-col-acciones" aria-label="Acciones"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rows.map((row, index) => {
                                                            const { valorCU, valorNeto } = calcularFila(row);
                                                            const largoArticulo = String(row.Articulos || '').length;
                                                            return (
                                                                <tr key={row.ID || `nuevo-${index}`}>
                                                                    <td className="cv-num">{row.Item}</td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            inputMode="numeric"
                                                                            className="cv-input cv-input-numero"
                                                                            placeholder="1"
                                                                            value={row.Cantidad}
                                                                            onChange={(e) => actualizarFila(index, "Cantidad", e.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="cv-input"
                                                                            placeholder="C/U, Hrs, Kg"
                                                                            maxLength={LARGO_MAX.unidad}
                                                                            value={row.Unidad}
                                                                            onChange={(e) => actualizarFila(index, "Unidad", e.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <textarea
                                                                            rows={1}
                                                                            ref={ajustarAlto}
                                                                            className="cv-input cv-articulo"
                                                                            placeholder="Descripción del producto o servicio"
                                                                            maxLength={LARGO_MAX.articulos}
                                                                            value={row.Articulos}
                                                                            onChange={(e) => {
                                                                                ajustarAlto(e.target);
                                                                                actualizarFila(index, "Articulos", e.target.value);
                                                                            }}
                                                                        />
                                                                        {largoArticulo > 0 && (
                                                                            <small className={`cv-contador${largoArticulo > LARGO_MAX.articulos - 25 ? ' cv-cerca-limite' : ''}`}>
                                                                                {largoArticulo}/{LARGO_MAX.articulos}
                                                                            </small>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            inputMode="numeric"
                                                                            className="cv-input cv-input-numero"
                                                                            placeholder="15.000"
                                                                            value={row.Valor}
                                                                            onChange={(e) => actualizarFila(index, "Valor", e.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td className="cv-calculado">${formatRemuneracion(valorCU.toString())}</td>
                                                                    <td className="cv-calculado cv-neto">${formatRemuneracion(valorNeto.toString())}</td>
                                                                    <td className="cv-col-acciones">
                                                                        <button type="button" onClick={() => eliminarFila(index)} className="cv-btn-quitar" title="Quitar ítem">
                                                                            <i className="fas fa-trash-alt"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="cotventa-items-pie">
                                                <button type="button" onClick={agregarFila} className="btn btn-outline-primary btn-sm">
                                                    <i className="fas fa-plus mr-1"></i> Agregar ítem
                                                </button>
                                                <div className="cotventa-total">
                                                    Total costo neto <strong>${formatRemuneracion(calcularTotal().toString())}</strong>
                                                </div>
                                            </div>
                                            <div className="cotventa-acciones">
                                                {editar ? (
                                                    <>
                                                        <button type="button" className="btn btn-outline-danger" onClick={limpiarCampos}>Cancelar</button>
                                                        <button type="button" onClick={UpdateCotizacionVenta} className="btn btn-success">
                                                            <i className="fas fa-save mr-1"></i> Guardar cotización
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button type="button" onClick={RegistraCotizacion} className="btn btn-success">
                                                        <i className="fas fa-check mr-1"></i> Registrar cotización
                                                    </button>
                                                )}
                                                <button type="button" className="btn btn-primary" onClick={exportarPDF}>
                                                    <i className="fas fa-file-pdf mr-1"></i> Exportar PDF
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="card shadow mb-4">
                                        <div class="card-header py-3">
                                            <h6 class="m-0 font-weight-bold text-primary">Listado de cotizaciones</h6>
                                        </div>
                                        <div class="card-body">
                                            {
                                                <div>
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead>
                                                                <tr>
                                                                    <th>N°</th>
                                                                    <th>Empresa</th>
                                                                    <th>Telefono</th>
                                                                    <th>Email</th>
                                                                    <th>Utilidad</th>
                                                                    <th>Acciones</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    Array.isArray(listadoCotizacion) && listadoCotizacion.length > 0 ? (
                                                                        listadoCotizacion.map((val, key) => (
                                                                            <tr key={key}>
                                                                                <th scope="row">{val.ID}</th>
                                                                                <td data-label="Empresa">{val.Nombre_Empresa}</td>
                                                                                <td data-label="Telefono">{val.Telefono}</td>
                                                                                <td data-label="Email">{val.Email}</td>
                                                                                <td data-label="Utilidad">{val.Utilidad}</td>
                                                                                <td data-label="Acciones">
                                                                                    <div className="btn-group" role="group" aria-label="Basic example">
                                                                                        <button type="button" onClick={() => { obtenerCotizacion(val.ID); }} className="btn btn-info btn-sm">Seleccionar</button>
                                                                                        <button type="button" onClick={() => DeleteCotizacionVenta(val.ID)} className="btn btn-danger btn-sm">Eliminar</button>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr><td colSpan="15">No hay información.</td></tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body >
    )
}

export default CotizacionVenta;
